import { useEffect, useState } from 'react';

import { AssetSidebar } from '@atom/map';
import { Icon, IconButton, Modal } from '@atom/mui';
import { CloseIcon } from '@atom/mui/icons';
import { TaskLocation } from '@atom/types/taskLocation';

import TaskMap from './TaskMap';
import TaskMapSidebar from './TaskMapSidebar';

import classes from './taskMapModal.module.css';

const styles = {
  modalContent: { padding: '0' },
};

export interface Props {
  open: boolean;
  onClose: () => void;
  handleAddLocationClickFromMap: () => void;
  handleEditLocationClickFromMap: (location: TaskLocation) => void;
  handleAddAssetClickFromMap: () => void;
  viewAssetId: string;
  setViewAssetId: (assetId: string) => void;
}

const TaskMapModal = ({
  open,
  onClose,
  handleAddLocationClickFromMap,
  handleEditLocationClickFromMap,
  handleAddAssetClickFromMap,
  viewAssetId,
  setViewAssetId,
}: Props) => {
  const [hoverId, setHoverId] = useState<string>('');
  const [selectedAssetId, setSelectedAssetId] = useState<string>(viewAssetId);

  useEffect(() => {
    setSelectedAssetId(viewAssetId);
  }, [viewAssetId]);

  const onTrayClose = () => {
    setHoverId('');
    setSelectedAssetId('');
    setViewAssetId('');
  };

  const activeMarkerId = hoverId || selectedAssetId;

  return (
    <Modal
      open={open}
      title={
        <div className={classes.modalHeader}>
          <div>Map</div>
          <IconButton onClick={onClose} data-cy="taskMapModalCloseButton">
            <Icon icon={CloseIcon} />
          </IconButton>
        </div>
      }
      contentStyle={styles.modalContent}
      width="xxxl"
      onCancel={onClose}
      disableFooter
    >
      <div className={classes.modalContent}>
        {selectedAssetId ? (
          <div className={classes.assetSidebarContainer}>
            <AssetSidebar id={selectedAssetId} onClose={onTrayClose} />
          </div>
        ) : (
          <TaskMapSidebar
            setHoverId={setHoverId}
            selectedAssetId={selectedAssetId}
            setSelectedAssetId={setSelectedAssetId}
            handleAddLocationClickFromMap={handleAddLocationClickFromMap}
            handleEditLocationClickFromMap={handleEditLocationClickFromMap}
            handleAddAssetClickFromMap={handleAddAssetClickFromMap}
          />
        )}
        <div className={classes.mapContainer}>
          <TaskMap hoverId={activeMarkerId} />
        </div>
      </div>
    </Modal>
  );
};

export default TaskMapModal;
